import ViewClientsPage from "components/viewClients/ViewClients.component"

const ViewClients = () => {
  return (
    <ViewClientsPage />
  )
}

export default ViewClients
